/**
 * 即梦 3.0（doubao-seedream-3-0-t2i-250415）manifest
 * 数据来源：image.json field_map（旧模型，接口 disable: true）
 * 特点：无清晰度/质量分档；比例带真实像素；参考图上限 1；无参考模式选择；图生图时隐藏比例/尺寸
 */
import type { ImageModelConfig } from '../../types';

export const jimeng3_0: ImageModelConfig = {
  id: '01K1DDJQKJVS5CZXT6D4FNR5A0',
  displayName: '即梦 3.0',

  defaults: {
    ratio: '1:1', // 接口 select: true 项
  },

  ratioOptions: {
    '*': [
      { label: '1:1', value: '1:1', width: 2048, height: 2048 },
      { label: '2:3', value: '2:3', width: 832, height: 1248 },
      { label: '3:2', value: '3:2', width: 1248, height: 832 },
      { label: '3:4', value: '3:4', width: 864, height: 1152 },
      { label: '4:3', value: '4:3', width: 1152, height: 864 },
      { label: '9:16', value: '9:16', width: 720, height: 1280 },
      { label: '16:9', value: '16:9', width: 1280, height: 720 },
      { label: '21:9', value: '21:9', width: 1512, height: 648 },
    ],
  },

  resolutionOptions: [],
  qualityOptions: [],

  // 即梦3.0 图生图（有参考图）时隐藏比例/尺寸（原硬编码：有参考图则删 image_ratio/width/height）
  refImageHidesRatio: true,

  toggles: {},

  limits: {
    maxRefImages: 1, // 接口 field_map.ref_images.max
  },
};
